/**
 * ENG-2624 — whether switching to a given editor tool should PRESERVE the current
 * canvas selection.
 *
 * The Select and Move (Hand) tools both support the multi-selection + bulk panel,
 * so a marquee / Cmd+click selection must survive switching between them (e.g.
 * select some lines in Select mode, then grab Move to pan, delete, or re-classify).
 * Every other tool (comment, and any unknown default) clears the selection.
 */
export function toolChangePreservesSelection(type: string): boolean {
  return type === 'select' || type === 'hand'
}
